var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useFormikContext } from "formik";
import React from "react";
import styled from "styled-components";
import { Body1 } from "../Text";
import { Div } from "../utils";
export const ErrorMessageWarningContainer = styled(Div) `
  color: ${(p) => p.theme.colors.black80};
  padding: 12px 16px;
  border: 1px solid ${(p) => p.theme.colors.error40};
  border-radius: 4px;
  background-color: ${(p) => p.theme.colors.error10};
`;
export const ErrorMessageWarning = (_a) => {
    var { children = null } = _a, props = __rest(_a, ["children"]);
    const { submitCount, touched, errors } = useFormikContext();
    let isDisplayingErrors = false;
    const fields = Object.keys(touched);
    for (let i = 0; i < fields.length; i++)
        if (errors[fields[i]])
            isDisplayingErrors = true;
    return (React.createElement(React.Fragment, null, submitCount > 0 && isDisplayingErrors && (React.createElement(ErrorMessageWarningContainer, Object.assign({}, props), children || (React.createElement(Body1, null, "Please review the highlighted errors before attempting your submission again."))))));
};
//# sourceMappingURL=ErrorMessageWarning.js.map